import {Component, Inject, OnInit} from '@angular/core';
import {CardAssignment} from '../../assignments-card/card-assignment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Router, NavigationExtras} from '@angular/router';
import {Card} from '../../../../card-container/card/card';
import {CardFeesAndBilling} from '../card-fees-and-billing';
import {LoginService} from '../../../../../../shared-modules/login/login.service';
import {UserService} from '../../../../../../shared-components/user/user.service';
import {OnlinePaymentConfiguration} from '../../../../../online-payment/models/online-payment-config.model';

@Component({
    selector: 'app-fees-and-billing-card-modal',
    templateUrl: './fees-and-billing-card-modal.component.html',
    styleUrls: ['./fees-and-billing-card-modal.component.css']
})
export class FeesAndBillingCardModalComponent implements OnInit {
    card: Card;
    v10: boolean;
    totalString = '';
    feesLedger: CardFeesAndBilling[] = [];
    displayedColumns: string[] = ['Code', 'Description', 'Balance', 'CreditOrDue'];
    onlinePaymentConfiguration: OnlinePaymentConfiguration = new OnlinePaymentConfiguration();
    userType: number;
    showPay = false;
    creditOrDue: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private router: Router,
                private loginService: LoginService,
                private userService: UserService,
                private dialogRef: MatDialogRef<FeesAndBillingCardModalComponent>) {
    }

    ngOnInit() {
        this.v10 = this.loginService.LoginSettings.V10;
        this.userType = this.userService.userType;
        this.showPay = this.data.showPay;
        this.feesLedger = this.data.feesLedger;
        this.totalString = this.data.totalString;
        this.creditOrDue = this.feesLedger[0].TotalBalanceCreditOrDue;
    }

    viewDetailsClick() {
        this.router.navigateByUrl('/student360/feesAndBilling');
        this.dialogRef.close();
    }

    checkIfMissing(assignment: CardAssignment) {
        // If missing return the isMissing class
        if (assignment.IsMissing) {
            return 'isMissing';
        }
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    closeClick() {
        this.dialogRef.close();
    }

    checkTotalString(totalString: string) {
        if (this.creditOrDue.includes('Due')) {
            return 'redText';
        }
        if (totalString == 'No fees owed for this student.') {
            return 'smallSummaryText';
        }
        if (this.creditOrDue.includes('Credit')) {
            return 'blackText';
        }
    }

    checkIfBalance() {
        if (this.totalString == 'No fees owed for this student.') {
            return false;
        } else {
            return true;
        }
    }

    payClick() {
        const navigationExtras: NavigationExtras = {
            // The view to Fee & Billing Accounts
            queryParams: {
                'selectedView': 1
            }
        };
        this.router.navigate(['/student360/onlinePayment'], navigationExtras);
        this.dialogRef.close();
    }

}
